import React from 'react'
import RootRouter from './routers/RootRouter'

import 'antd/dist/antd.css'
import 'react-phone-number-input/style.css'

import { Request } from 'fetchboi'
import { baseAPIRoot } from './config/index.config'
import { setLocale } from 'yup'

import catalogEN from './locales/en/messages'
import catalogES from './locales/es/messages'
import LocaleProvider from './providers/Locale/localeProvider'
import { ThemeProvider } from 'styled-components'
import { theme } from './styling/styled-system'
import URLParamsProvider from './providers/URLParams/URLParamsProvider'

Request.init(baseAPIRoot)

setLocale({
  string: {
    //required: 'Este campo es requerido',
  },
})

const catalogs = {
  en: catalogEN,
  es: catalogES,
}


const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <URLParamsProvider>
        <LocaleProvider>
          <RootRouter/>
        </LocaleProvider>
      </URLParamsProvider>
    </ThemeProvider>
  )
}

export default App
